




































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import HoldFileAttachments from "@/view/hold/components/HoldFileAttachments.vue";
import HoldQiDetailsForm from "@/view/hold/components/HoldQiDetailsForm.vue";
import HoldSAPForm from "@/view/hold/components/HoldSAPForm.vue";
import HoldMaterialForm from "@/view/hold/components/HoldMaterialForm.vue";
import HoldDefectForm from "@/view/hold/components/HoldDefectForm.vue";
import HoldDispositionForm from "@/view/hold/components/HoldDispositionForm.vue";
import HoldQiDetails from "@/domainObjects/hold/HoldQiDetails";
import TicketService from "@/services/TicketService";
import alertMixin from "@/mixins/alert-mixin";
import SubmitTicketButtonGroupMobile from "@/view/shared-components/mobile-only/SubmitTicketButtonGroupMobile.vue";
import SubmitTicketButtonGroupDesktop from "@/view/shared-components/desktop-only/SubmitTicketButtonGroupDesktop.vue";
import screenSizeMixin from "@/mixins/screen-size-mixin";
import {mapGetters} from "vuex";
import Plant from "@/domainObjects/Plant";
import Disposition from "@/domainObjects/hold/Disposition";

@Component ({
    components: {
        SubmitTicketButtonGroupDesktop,
        SubmitTicketButtonGroupMobile,
        HoldDispositionForm,
        HoldDefectForm,
        HoldMaterialForm,
        HoldSAPForm,
        HoldQiDetailsForm,
        HoldFileAttachments,
    },
    mixins: [alertMixin, screenSizeMixin],
    computed: {
        // TODO: should change to mapState at some point
        ...mapGetters(['getFirstName', 'getLastName']),
    }
})

export default class AddHoldTicketPage extends Vue {
    @Prop({required: false}) plant!: Plant;

    private allowSubmit: boolean = false;
    private allowReset: boolean = false;
    private holdTicket: HoldTicket = new HoldTicket();
    private originalHoldTicketStringified: string = "";
    private getFirstName!: string;
    private getLastName!: string;
    private busy: boolean = false;
    $_alertMixin_swalConfirm!: (heading: string | null, message: string | null, type: string | null) => Promise<boolean>;
    $_alertMixin_saveSuccess!: () => void;


    @Watch('holdTicket', {immediate: true, deep: true})
    onPropertyChange(value: HoldTicket, oldvalue: HoldTicket){
        let newHoldTicketStringified = JSON.stringify(value);
        this.allowReset = this.originalHoldTicketStringified !== newHoldTicketStringified;
        this.allowSubmit = !!(value.productionOrderNum &&
                value.plant.code &&
                value.plant.code.length > 0 &&
                value.productionOrderQty &&
                value.materialDesc &&
                value.comments &&
                value.materialNumber &&
                value.onHoldBy &&
                value.salesOrderNumber &&
                value.lineItem &&
                value.color &&
                value.optionNumber &&
                value.quantityOnHold &&
                value.productionDate &&
                value.skidsOnHold &&
                value.producedByShift &&
                value.skidNumsOnHold &&
                value.workCenter &&
                value.defect.id);
    }

    constructor(){
        super()
    }

    beforeMount(){
        this.setInitialValues()
    }

    mounted(){
        this.holdTicket.onHoldBy = this.getFirstName + ' ' + this.getLastName;
    }

    setInitialValues(){
        this.holdTicket = new HoldTicket();
        let holdTicketObj:any = {};
        holdTicketObj.plant = {};
        holdTicketObj.status = {};
        holdTicketObj.defect = {};
        holdTicketObj.disposition = {};
        holdTicketObj.disposition.id = Disposition.AWAITING_DISPOSITION;
        holdTicketObj.disposition.desc = "Awaiting Disposition";
        holdTicketObj.status.id = 9;
        holdTicketObj.status.desc = 'Open';
        if (this.plant){
            holdTicketObj.plant = this.plant;
        }
        holdTicketObj.onHoldDate = new Date();
        holdTicketObj.returnAuthNum = 'N/A';
        holdTicketObj.purchaseOrderNum = 'N/A';
        holdTicketObj.cparNumber = 'N/A';
        holdTicketObj.color = 'N/A';
        holdTicketObj.optionNumber = 'N/A';
        holdTicketObj.holdQiDetails = [new HoldQiDetails()];
        this.holdTicket.initFromObject(holdTicketObj);
        this.holdTicket.loaded = true;
        this.originalHoldTicketStringified = JSON.stringify(this.holdTicket);
    }

    onSubmit() {
        let self = this;
        this.$_alertMixin_swalConfirm('Submit Ticket', null, null).then((value) => {
            if (value) {
                self.busy = true;
                let holdTicketJSON = JSON.stringify(self.holdTicket);
                TicketService.createHoldTicket(holdTicketJSON).then((response) => {
                    this.holdTicket.holdTicketId = parseInt(response.data)
                    if (this.holdTicket.dispositionBy &&
                        this.holdTicket.dispositionDate &&
                        this.holdTicket.disposition.id !== Disposition.ACCEPT_AS_IS &&
                        this.holdTicket.disposition.id !== Disposition.AWAITING_DISPOSITION &&
                        this.holdTicket.disposition.id !== Disposition.MEETS_SPEC
                    ) {
                        this.holdTicket.actionTrackingAvailable = true;
                    }
                    self.$_alertMixin_saveSuccess();
                    self.busy = false;
                    // @ts-ignore
                    this.$router.push({name: 'hold-tickets', params: {updatedTicket: this.holdTicket, updatedTicketType:'created'}})
                }).catch((error) => {
                });
            }
        });
    }
    onReset() {
        this.holdTicket.loaded = false;
        this.$nextTick(() => {
            this.holdTicket = {} as HoldTicket;
            this.setInitialValues();
        });
    }

    validDefectSelected(){
        if (this.holdTicket.defect.id === 5 || this.holdTicket.defect.id === 8 || this.holdTicket.defect.id === 9){
            return false
        }
        return true
    }
}
